/**
*
* 从getter中取数据到组件中
*
*/
export const skin = state => state.skin
export const token = state => state.token
export const datumValue = state => state.datumValue
export const datumObj = state => state.datumObj
export const menuActiveName = state => state.menuActiveName
export const menuOpenName = state => state.menuOpenName
export const pageSize = state => state.pageSize
export const modelDisabled = state => state.modelDisabled
export const crumbsList = state => state.crumbsList
export const menuList = state => state.menuList
export const bindPhone = state => state.bindPhone


// WEBPACK FOOTER //
// ./src/store/getters.js